import React from 'react';
import classnames from 'classnames';
import './InputGroup.scss';

const InputGroup = ({ children, className }) => {
    return <div className={classnames(['mykmx-input-group', className])}>{children}</div>;
};

export default InputGroup;
